import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import TableDataBlk from "./tableDataBlk";

const TableData = ({
  data,
  hideSearch,
  ownerData,
  pageNo,
  ownerEmail,
  setPageNo,
}) => {
  const initialPage = pageNo - 1;
  const navigate = useNavigate();
  const { propertiesCount: reportedCount } = ownerData;
  // Defensive two-sided clamp around the backend's owner.propertiesCount,
  // which has been observed both under-reporting (e.g. saying 2 when the
  // listing actually has 10 rows → impossible "Showing 1 to 10 of 2" text)
  // AND over-reporting (e.g. saying 199 when only 188 actually exist →
  // pagination renders 20 pages but page 20 is a phantom blank).
  //
  //   1. visibleThroughCurrentPage gives a hard LOWER bound — we know at
  //      least this many rows exist because we just rendered them.
  //   2. isPartialPage gives a hard UPPER bound — once we hit a page that
  //      has fewer than PAGE_SIZE rows, we know it's the last real page
  //      and the true total is exactly visibleThroughCurrentPage.
  // Combined with the empty-page redirect in owner-property/Index.jsx,
  // this also prevents the blank-page crash that happens when users
  // navigate to a phantom page.
  const PAGE_SIZE = 10;
  const visibleThroughCurrentPage =
    (pageNo - 1) * PAGE_SIZE + (data?.length || 0);
  const isPartialPage = data?.length > 0 && data.length < PAGE_SIZE;
  const propertiesCount = isPartialPage
    ? visibleThroughCurrentPage
    : Math.max(Number(reportedCount) || 0, visibleThroughCurrentPage);
  const [pageCount, setPageCount] = useState(0);

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
    navigate(`/owner-property/${ownerEmail}?page=${event.selected + 1}`);
  };

  useEffect(() => {
    setPageCount(Math.ceil(propertiesCount / 10));
  }, [propertiesCount]);
  return (
    <>
      <section
        className={
          hideSearch ? "table_view_sec filter_show_after" : "table_view_sec owner_table"
        }
      >
        <div className="contain-fluid">
          <div className="inner_tbl">
            <table>
              <thead>
                <tr>
                  <th>Address</th>
                  <th>Last Sale</th>
                  <th>Sales Price</th>
                  <th>Year Built</th>
                  <th>Building Area</th>
                  <th>Units</th>
                  <th>Property Type</th>
                  <th>Contact Info</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((val, i) => {
                  return <TableDataBlk val={val} i={i} />;
                })}
              </tbody>
            </table>
            <div className="pagination_blk">
              <div className="colL">
                <span>
                  {propertiesCount == 0
                    ? "0 property."
                    : "Showing " +
                      ((pageNo - 1) * 10 + 1) +
                      " to " +
                      ((pageNo - 1) * 10 + data.length) +
                      " of " +
                      propertiesCount +
                      (propertiesCount > 1 ? " properties" : " property")}
                </span>
              </div>
              <div className="colR">
                <div className="pagination_slider">
                  <ReactPaginate
                    forcePage={initialPage}
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={10}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TableData;
